/**
 * Multiplex: Discounted price (per 10s, per screen, per week) × screens × weeks × seconds-block.
 *
 *   - screens: Σ of selected screens' DiscountedPrice (per-screen rates summed)
 *   - weeks:   number of weeks selected (direct count)
 *   - seconds: tenBlockFactor(BoughtSeconds) → 10s ×1, 20s ×2, 30s ×3
 *
 *   Total = (Σ screen DiscountedPrice) × weeks × tenBlockFactor(BoughtSeconds)
 * Example: 2 screens @100, 2 weeks, 20s → 200 × 2 × 2 = 800.
 */
import { tenBlockFactor } from './multipliers';

export function calculateMultiplexTotal(variant, selection) {
  const productsToBuy = selection?.ProductsToBuy || selection?.selectedRows || [];
  if (!productsToBuy.length) return 0;

  const sumDiscountedMRP = productsToBuy.reduce((sum, row) => sum + (Number(row?.DiscountedPrice) || 0), 0);
  const weeks = Number(selection?.timelineToBought) > 0 ? Number(selection.timelineToBought) : 1;
  const boughtSeconds = Number(selection?.BoughtSeconds) || 0;
  const sMult = boughtSeconds > 0 ? tenBlockFactor(boughtSeconds) : 1;
  return sumDiscountedMRP * weeks * sMult;
}
